import React from "react";
import { IonIcon } from "@ionic/react";
import { businessOutline, chevronDown, chevronForward } from "ionicons/icons";
import { ShareableOrg } from "../../../services/orgSharing";

// Parent/top-level org row in the sharing accordion (ACDPA-186). It is a HEADER only — a patient
// can never share with a parent org, so there is no Share action here. Tapping it expands/collapses
// the org's locations (where the Share action lives). Mirrors OrgRow's icon + layout so the header
// and its location rows read as one group.
type Props = {
  org: ShareableOrg;
  /** How many shareable/location rows sit under this parent (shown as a subtle count). */
  locationCount: number;
  expanded: boolean;
  onToggle: () => void;
};

const OrgAccordionHeader: React.FC<Props> = ({ org, locationCount, expanded, onToggle }) => (
  <button
    type="button"
    className="care-org-accordion-header"
    onClick={onToggle}
    aria-expanded={expanded}
    aria-label={`${expanded ? "Collapse" : "Expand"} ${org.name} locations`}
  >
    <div className="care-org-row-lead">
      <div className="care-org-avatar">
        <IonIcon icon={businessOutline} />
      </div>
      <div style={{ minWidth: 0 }}>
        <div className="care-org-row-name">{org.name}</div>
        <div className="care-org-row-meta">
          {locationCount === 1 ? "1 location" : `${locationCount} locations`}
        </div>
      </div>
    </div>
    <IonIcon
      className="care-org-chevron"
      icon={expanded ? chevronDown : chevronForward}
      aria-hidden="true"
    />
  </button>
);

export default OrgAccordionHeader;
